import React from 'react';
import { R } from '@leverege/value-resolver';
import { Pane, Text } from '@leverege/ui-elements';
import { businessStates } from '../../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const VARIANTS = {
  lost: 'pillWarning|pill',
  'suspected-drive-off': 'pillWarning|pill',
  'suspected-off-lot': 'pillWarning|pill',
  'support-required': 'pillWarning|pill',
  'non-operational': 'pillError|pill',
  'sale-pending': 'pillError|pill',
  'sale-pending-remove': 'pillError|pill',
  'sale-pending-replace': 'pillError|pill',
  'sold-low-battery': 'pillError|pill',
  'sold-offline': 'pillError|pill',
  pendingAddLocator: 'pillError|pill'
};
export default function LocatorStatus(props) {
  const {
    value,
    defaultValue = '---'
  } = props;
  if (typeof value !== 'string' || !value) {
    return defaultValue;
  }
  return /*#__PURE__*/_jsx(Pane, {
    variant: "tableCellContent",
    children: /*#__PURE__*/_jsx(Text, {
      variant: VARIANTS[value] || 'pill',
      children: R(businessStates)[value] || value
    })
  });
}